import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsMcpServersOptions } from '@onefootprint/fetch-dashboard';
import type { AgentTool } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { humanizeVendorKind } from '@/utils/vendor-kind';
import { isBuiltinTool, isMcpTool } from '../../store/types';
type ToolAvailabilityRowProps = {
  tools: AgentTool[];
};
const ToolAvailabilityRow = t0 => {
  const $ = _c(20);
  const {
    tools
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.managed"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== tools) {
    t2 = tools.some(isMcpTool);
    $[1] = tools;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const hasMcpTools = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getOrgAgentsMcpServersOptions();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== hasMcpTools) {
    t4 = {
      ...t3,
      enabled: hasMcpTools
    };
    $[4] = hasMcpTools;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: servers
  } = useQuery(t4);
  if (tools.length === 0) {
    return null;
  }
  let t5;
  if ($[6] !== servers) {
    t5 = tool => {
      if (isMcpTool(tool)) {
        return servers?.find(s => s.id === tool.data.serverId)?.name ?? tool.data.serverId;
      }
      if (isBuiltinTool(tool)) {
        return humanizeVendorKind(tool.data.kind);
      }
      return humanizeVendorKind(tool.data.vendorKind);
    };
    $[6] = servers;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const labelFor = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <span>{t6}</span>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== labelFor || $[13] !== tools) {
    let t9;
    if ($[15] !== labelFor) {
      t9 = tool_0 => {
        const label = labelFor(tool_0);
        return <Tag key={label}>{label}</Tag>;
      };
      $[15] = labelFor;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    t8 = tools.map(t9);
    $[12] = labelFor;
    $[13] = tools;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="flex flex-wrap items-center gap-2 text-caption-3 text-tertiary md:flex-nowrap">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
export default ToolAvailabilityRow;
function _temp($) {
  return $.requiresTools;
}